jQuery(document).foundation();

// Blur background not working, it blurs the entire modal not just background
// jQuery(function () {
//   jQuery('#overlayButton').click(function () {
//     jQuery('.reveal-overlay').addClass('open');

//     if (jQuery('.reveal-overlay').hasClass('open')) {
//       jQuery('.reveal-overlay').addClass('overlayContainer_blur');
//     }
//   });

//   jQuery('.close').click(function () {
//     jQuery('.reveal-overlay').removeClass('open');
//     jQuery('.reveal-overlay').removeClass('overlayContainer_blur');
//   });
// });